import CryptoJS from 'crypto-js';
import ignore from 'ignore';
import GitIgnore from '~/components/campaign/.gitignore';

interface FileMetadata {
    path: string;
    size: number;
    lastModified: number;
}

export class FolderHasher {
    private ig = ignore().add(GitIgnore);

    public shouldIncludePath(path: string): boolean {
        // Exclude hidden files and .git directory
        if (path.startsWith('.') || path.includes('/.')) {
            return false;
        }
        // Check against gitignore patterns
        return !this.ig.ignores(path);
    }

    // Calculate a lightweight hash based on file metadata
    private calculateMetadataHash(metadata: FileMetadata[]): string {
        // Sort to ensure consistent order
        const sortedMetadata = metadata.sort((a, b) => a.path.localeCompare(b.path));

        // Create a string combining all metadata
        const metadataString = sortedMetadata.map(m =>
            `${m.path}:${m.size}:${m.lastModified}`
        ).join('|');

        // Calculate hash
        return CryptoJS.SHA256(metadataString).toString();
    }

    async getFolderHash(directoryHandle: FileSystemDirectoryHandle): Promise<string> {
        const metadata: FileMetadata[] = [];

        const collectMetadata = async (handle: FileSystemDirectoryHandle, path: string = '') => {
            for await (const entry of (handle as any).values()) {
                const entryPath = path ? `${path}/${entry.name}` : entry.name;

                if (!this.shouldIncludePath(entryPath)) {
                    continue;
                }

                if (entry.kind === 'file') {
                    const file = await entry.getFile();
                    metadata.push({
                        path: entryPath,
                        size: file.size,
                        lastModified: file.lastModified
                    });
                } else if (entry.kind === 'directory') {
                    await collectMetadata(entry, entryPath);
                }
            }
        };

        await collectMetadata(directoryHandle);
        return this.calculateMetadataHash(metadata);
    }
}